import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule, MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import {
  FPX_FORM_FIELD_DEFAULT_OPTIONS,
  FPX_MAT_CHECKBOX_DEFAULT_OPTIONS,
  FPX_MAT_DISABLE_RIPPLE,
  FPX_MAT_RADIO_DEFAULT_OPTIONS,
  FPX_MAT_SELECT_DEFAULT_OPTIONS,
  MY_DATE_FORMATS,
} from '../constant/index';
import { MatBadgeModule } from '@angular/material/badge';
import {
  DateAdapter,
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
} from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {
  MatRadioModule,
  MAT_RADIO_DEFAULT_OPTIONS,
} from '@angular/material/radio';
import {
  MatCheckboxModule,
  MAT_CHECKBOX_DEFAULT_OPTIONS,
} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';


@NgModule({
  exports: [
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatBadgeModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatIconModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatTableModule,
    MatSliderModule,
    MatSlideToggleModule,
    
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { ...FPX_FORM_FIELD_DEFAULT_OPTIONS },
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { ...FPX_MAT_RADIO_DEFAULT_OPTIONS },
    },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: FPX_MAT_CHECKBOX_DEFAULT_OPTIONS,
    },
    {
      provide : MAT_SELECT_CONFIG ,
      useValue : { ...FPX_MAT_SELECT_DEFAULT_OPTIONS}
    },
    {
      provide : MAT_DATE_FORMATS,
      useValue : {...MY_DATE_FORMATS}
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: { ...FPX_MAT_DISABLE_RIPPLE },
    },
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  ],
})
export class MaterialModule {}
